import { useAuth0 } from '@auth0/auth0-react';
import { Button } from 'components/ui/button';
import { Card } from 'components/ui/card';
import { SIGN_IN_PATH } from 'lib/login-method';
import React from 'react';
import { Link } from 'react-router-dom';

function SignUpPage () {
  const { loginWithRedirect } = useAuth0();

  const handleSignUp = () => {
    // screen_hint opens Universal Login directly on the signup screen
    loginWithRedirect({
      authorizationParams: { screen_hint: 'signup' },
      appState: { returnTo: '/chat' },
    });
  };

  return (
    <div className="min-h-screen bg-muted/40 p-8">
      <div className="mx-auto w-full max-w-md">
        <Card className="mt-8 flex flex-col items-center p-8 text-center">
          <img src="/assets/hilo-full-logo.png" alt="HiLo Analytics" className="mb-6 h-8" />
          <h3 className="mb-6 text-2xl font-semibold text-foreground">
            Create your account
          </h3>

          <Button
            size="lg"
            className="w-full"
            onClick={handleSignUp}
          >
            Continue with email
          </Button>
          <p className="mt-3 text-sm text-muted-foreground">
            We&apos;ll email you a one-time code to confirm your address.
          </p>

          <p className="mt-6 text-sm text-muted-foreground">
            Already have an account?{' '}
            <Link to={SIGN_IN_PATH} className="font-medium text-foreground underline">
              Sign in
            </Link>
          </p>
        </Card>
      </div>
    </div>
  );
}

export default SignUpPage;
